import { openBlock as t, createElementBlock as n, normalizeClass as i, normalizeStyle as o, createElementVNode as a } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-dad06003.js";
const r = {
  name: "rIcon",
  props: {
    /**
     * icon 名称
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * 尺寸
     */
    size: {
      type: Number,
      default: 16
    },
    /**
     * 模式，svg | font-class
     */
    mode: {
      type: String,
      default: "font-class"
    },
    /**
     * 宽度，svg模式下可用
     */
    width: {
      type: [String, Number],
      default: "auto"
    },
    /**
     * 高度，svg模式下可用
     */
    height: {
      type: [String, Number],
      default: "auto"
    }
  }
}, s = ["width", "height"], l = ["xlink:href"];
function d(m, u, e, h, f, _) {
  return e.mode !== "svg" ? (t(), n(
    "i",
    {
      key: 0,
      class: i(["r-icon bmicon", `${e.name}`]),
      style: o({ fontSize: `${e.size}px` })
    },
    null,
    6
    /* CLASS, STYLE */
  )) : (t(), n("svg", {
    key: 1,
    class: "r-icon",
    "aria-hidden": "true",
    width: e.width,
    height: e.height
  }, [
    a("use", {
      "xlink:href": `#${e.name}`
    }, null, 8, l)
  ], 8, s));
}
const k = /* @__PURE__ */ c(r, [["render", d], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/icon/icon.vue"]]);
export {
  k as I
};
